<template>
  <div class="selector-container">
    <div class="selector">
      <div
        v-for="option in props.options"
        :key="option.id"
        :class="{
          'option-selected': option.id === selected.id,
          'currency-option': props.isCurrencySelector,
          'custom-style': sortBySelector,
        }"
        class="option"
        :data-size="props.size"
        @click="handleSelected(option)"
      >
        {{ option[displayKey] }}
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['update:selected']);
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  selected: {
    type: Object,
    required: false,
    default: () => ({ name: 'No', key: 'no', id: '2' }),
  },
  displayKey: {
    type: String,
    default: 'name',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isCurrencySelector: {
    type: Boolean,
    default: false,
  },
  sortBySelector: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'medium',
  },
});
function handleSelected(option) {
  if (!props.disabled && option.id !== props.selected.id) {
    emit('update:selected', option);
  }
}
</script>

<style scoped lang="scss">
@use '@/scss/main.scss';

.selector-container {
  .selector {
    display: flex;
  }
  .option {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    font-size: main.$font-size-sm;
    font-weight: main.$font-weight-semibold;
    line-height: 1rem;
    color: main.$blue-903_01;
    background: main.$blue-901_03;
    transition:
      background 0.2s ease,
      color 0.2s ease;
    user-select: none;

    &[data-size='small'] {
      padding: 0.5rem 0.75rem;
      font-size: 0.75rem;
    }

    &:first-child {
      border-radius: 6px 0 0 6px;
    }
    &:last-child {
      border-radius: 0 6px 6px 0;
    }
    &:first-child:last-child {
      border-radius: 6px;
    }
    &-selected {
      cursor: default;
      color: main.$white;
      background: main.$color-primary_03;
    }
    &.currency-option {
      font-size: 13px;
      width: -webkit-fill-available;
      width: -moz-available;
      place-content: center;

      &:first-child {
        border-top-left-radius: 25px;
      }
      &:last-child {
        border-top-right-radius: 25px;
      }
    }
  }
}
.spread-new {
  .option {
    padding: 0.75rem;
    border: 1px solid main.$color-primary;
  }
}
.custom-style {
  // width: 71.3px !important
  display: flex !important;
  justify-content: center !important;
  font-size: 11px !important;
}
</style>
